<template>
  <div class="max-w-xl bg-white shadow-md rounded-lg mx-auto p-4 my-10">
    <h3 class="text-lg font-semibold">
      {{ $t('home.welcome') }}
    </h3>
  </div>
</template>
